import { render, staticRenderFns } from "./PageBalance.vue?vue&type=template&id=5145efa4&scoped=true"
import script from "./PageBalance.vue?vue&type=script&lang=js"
export * from "./PageBalance.vue?vue&type=script&lang=js"
import style0 from "./PageBalance.vue?vue&type=style&index=0&id=5145efa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145efa4",
  null
  
)

export default component.exports